export enum IconTransactionType {
  TRANSFER,
  WRITE,
  READ,
}
